import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementForm } from '../../../shared-agreement.model';
import { ApiClientService } from '@services/api-client';

@UntilDestroy()
@Component({
    selector: 'app-general-info',
    templateUrl: './general-info.component.html',
    styleUrl: './general-info.component.scss'
})
export class GeneralInfoComponent {
    @Input() public agreementForm: FormGroup<AgreementForm>;
    @Input() public showPotentialValidationMessages: boolean;
    @Output() public fileDialogStateChange = new EventEmitter<boolean>();
    private readonly apiClientService = inject(ApiClientService);

    public get detailsForm() {
        return this.agreementForm.controls.details;
    }

    public get paymentForm() {
        return this.agreementForm.controls.payment;
    }

    public get realEstateForm() {
        return this.agreementForm.controls.realEstate;
    }

    public get rentalForm() {
        return this.agreementForm.controls.rental;
    }

    public get inventoryForm() {
        return this.agreementForm.controls.inventory;
    }

    public get fileForm() {
        return this.agreementForm.controls.fileUpload;
    }

    public get f() {
        return this.agreementForm.controls;
    }

    public onFileDialogStateChange(isOpen: boolean) {
        this.fileDialogStateChange.emit(isOpen);
    }
}
